import { Injectable } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { UtilsService } from '@app/providers/utils/utils.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EaRentFormPersonalUseService {
  generateSubject: Subject<UntypedFormGroup> = new Subject();

  constructor(
    protected estateDao: EstateDao,
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected prFormService: PrFormService,
    protected notificationsService: NotificationsService,
  ) {}

  public generate(entity: any) {
    let rents: UntypedFormGroup[] = [];
    if (entity.rents)
      for (let rent of entity.rents)
        rents.push(this.formBuilder.group(this.newModel(rent)));

    let group = this.formBuilder.group({
      rents: this.formBuilder.array(rents, Validators.nullValidator),
    });

    this.generateSubject.next(group);
    return group;
  }

  public extract(form) {
    return {
      rents: form.value.rents.map(rent => ({
        id: this.utilsService.emptyIsNull(rent.id),
        amount: this.utilsService.emptyIsNull(rent.amount),
        frequency: this.utilsService.emptyIsNull(rent.frequency),
        startDate: this.utilsService.emptyIsNull(rent.startDate),
        endDate: this.utilsService.emptyIsNull(rent.endDate),
        current: false,
        rentType: this.utilsService.emptyIsNull(rent.rentType),
        rentFiscalLaw: this.utilsService.emptyIsNull(rent.rentFiscalLaw),
        rentedArea: rent.isPartialRent
          ? this.utilsService.emptyIsNull(rent.rentedArea)
          : null,
        contactTenant: rent.tenant,
      })),
    };
  }

  public addModel(entity, formControls) {
    let model = {
      rentType: 'NUE',
      rentFiscalLaw: 'MICRO_FONCIER',
      isPartialRent: false,
      rentedArea: null,
    };
    if (!entity.rents) entity.rents = [];
    entity.rents.push(model);
    formControls.rents.push(this.formBuilder.group(this.newModel(model)));
  }

  public removeModel(index, rents, userId, estateTypeUrl, estateId) {
    let rent = rents.value[index];
    if (rent.id) {
      rent.accountId = userId;
      this.prFormService.loading();
      this.estateDao
        .deleteRealestateRent(userId, estateId, estateTypeUrl, rent.id)
        .subscribe(
          success => {
            this.prFormService.loaded();
            rents.removeAt(index);
          },
          errors => {
            console.error(errors);
            this.prFormService.loaded();
            this.notificationsService.error('La suppression a échoué');
          },
        );
    } else rents.removeAt(index);
  }

  newModel(model) {
    const isPartialRent =
      model?.isPartialRent || (model?.rentedArea != null && model?.rentedArea > 0);


    const rentType = model?.rentType || 'NUE';
    const defaultFiscalLaw = rentType === 'MEUBLEE' ? 'MICRO_BIC' : 'MICRO_FONCIER';

    return {
      id: [model ? model.id : null],
      amount: [model ? model.amount : null, Validators.required],
      startDate: [model ? model.startDate : null, Validators.required],
      endDate: [
        model ? model.endDate : null,
        isPartialRent ? null : Validators.required,
      ],
      frequency: [model ? model.frequency : 'MENS', Validators.required],
      rentType: [rentType, Validators.required],
      rentFiscalLaw: [model?.rentFiscalLaw || defaultFiscalLaw, Validators.required],
      isPartialRent: [isPartialRent],
      rentedArea: [
        model ? model.rentedArea : null,
        isPartialRent ? [Validators.required, Validators.min(1)] : null,
      ],
      tenant: this.formBuilder.group({
        id: [model?.contactTenant?.id || null],
        type: [model?.contactTenant?.type || 'INDIVIDUAL'],
        firstName: [model?.contactTenant?.firstName || null],
        lastName: [model?.contactTenant?.lastName || null],
        phone: [model?.contactTenant?.phone || null],
        email: [model?.contactTenant?.email || null],
      }),
    };
  }
}
